import { Heading, Picker, View, Item, TextField, Flex, Button, DialogTrigger } from '@adobe/react-spectrum';
import { PaymentMethodEnum } from '../constant';
import { useState } from 'react';
import PaymentSummaryPreview from './paymentSummaryPreview';
import { AddOnType, StudentPaymentData } from '../../types';

const PaymentMethod: React.FC<{ localStudentData: StudentPaymentData; finalCostComponent: AddOnType[] }> = ({ localStudentData, finalCostComponent }) => {
  const [transactionNumber, setTransactionNumber] = useState<string>();
  const [selectedMethod, setSelectedMethod] = useState<string>();
  const [openPreviewDialog, setOpenPreviewDialog] = useState<boolean>(false);

  return (
    <View paddingBottom={'size-6000'} marginTop={'size-300'}>
      <Heading margin={0} level={4}>
        Payment Method
      </Heading>
      <Flex gap={'size-200'} justifyContent={'space-between'}>
        <Flex gap={'size-100'}>
          <Picker width={'size-4600'} marginTop={'size-300'} selectedKey={selectedMethod} onSelectionChange={(value) => setSelectedMethod(value as string)}>
            <Item key="online">Online</Item>
            <Item key="cash">Cash</Item>
          </Picker>
          {selectedMethod === PaymentMethodEnum.ONLINE && (
            <TextField width={'size-4600'} label="Transaction number" value={transactionNumber} onChange={(value) => setTransactionNumber(value)} />
          )}
        </Flex>
        <Flex gap={'size-100'} marginTop={'size-300'}>
          <DialogTrigger type="fullscreen" isOpen={openPreviewDialog}>
            <Button
              variant="cta"
              onPress={() => setOpenPreviewDialog(true)}
              isDisabled={(selectedMethod === PaymentMethodEnum.ONLINE && !transactionNumber) || !selectedMethod}
            >
              Preview
            </Button>
            <PaymentSummaryPreview
              setOpenPreviewDialog={setOpenPreviewDialog}
              studentData={localStudentData}
              finalCostComponent={finalCostComponent}
              transactionNumber={transactionNumber as string}
              selectedMethod={selectedMethod as string}
            />
          </DialogTrigger>
        </Flex>
      </Flex>
    </View>
  );
};

export default PaymentMethod;
